import styled from "styled-components";
import appTheme from "../../themes/Theme";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import ArrowDropDownOutlinedIcon from "@material-ui/icons/ArrowDropDownOutlined";

export const StyledSelect = styled(Select)`
  && {
    color: ${appTheme.textColor};
    font-weight: 500;
    height: 32px;
    width: 50px;
    ::before {
      border-bottom: none;
    }
    ::after {
      border-bottom: none;
    }
    :hover:before {
      border-bottom: none !important;
    }
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  && {
    font-weight: 500;
  }
`;

export const StyledDropDownIcon = styled(ArrowDropDownOutlinedIcon)`
  && {
    color: ${appTheme.textColor};
  }
`;
